window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },
  isTouchDevice: function() {
    return 'ontouchstart' in window        // works on most browsers
        || navigator.maxTouchPoints;       // works on IE10/11 and Surface
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

// slate.tealium = {
//     addToCart: function(item, title, qty) {
//         if (typeof utag == "undefined" || typeof utag_data == "undefined")
//             return;

//         var cart_utag = {
//             "event": "scAdd",
//             "page" : "myBag",
//             "page_name" : utag_data.page_name || "",
//             "product_id": "" + item.id + "",
//             "product_name": title,
//             "product_mfgsku": item.sku,
//             "product_current_category": "",
//             "product_current_price": slate.Currency.formatMoney(item.price, '{{amount}}'),
//             "product_regular_price": slate.Currency.formatMoney(item.compare_at_price == null ? item.price : item.compare_at_price, '{{amount}}'),
//             "product_is_on_sale": item.compare_at_price == null ? 'false' : 'true',
//             "product_size": item.option1 || "",
//             "product_color": item.option2 || "",
//             "product_quantity": "" + qty + "",
//             "product_upc": item.barcode,
//             "customer_email": utag_data.customer_email || "",
//             "customer_id": utag_data.customer_id || "",
//             "customer_status": utag_data.customer_status || ""
//         };

//         utag.view(cart_utag);
//     },
//     removeCartItem: function(item) {
//         if (typeof utag == "undefined" || typeof utag_data == "undefined" || !item )
//           return;

//           utag.view({
//             "event": "scRemove",
//             "page" : "myBag",
//             "page_name" : "mini cart",
//             "product_id": "" + item.variant_id + "",
//             "product_name": item.product_title,
//             "product_mfgsku": item.sku,
//             "product_current_category": "",
//             "product_current_price": item.price,
//             "product_regular_price": item.original_price,
//             "product_is_on_sale": item.price < item.original_price ? 'true' : 'false',
//             "product_size": "",
//             "product_color": "",
//             "product_quantity": "" + item.quantity + "",
//             "product_upc": "",
//             "variant_options": item.variant_options || [],
//             "customer_email": utag_data.customer_email || "",
//             "customer_id": utag_data.customer_id || "",
//             "customer_status": utag_data.customer_status || ""
//           });
//       },
// }

/*================ Sections ================*/
/**
 * Line item properties from `properties[Key]` inputs (gift cards, preorder, etc.)
 * for /cart/add.js — skips disabled fields and unchecked checkboxes.
 */
theme.getLineItemPropertiesFromForm = function($form) {
  var properties = {};
  $form.find('input, textarea, select').each(function() {
    var $el = $(this);
    var name = $el.attr('name');
    if (!name || name.indexOf('properties[') !== 0) {
      return;
    }
    if ($el.prop('disabled')) {
      return;
    }
    var type = ($el.attr('type') || '').toLowerCase();
    if (type === 'checkbox' || type === 'radio') {
      if (!$el.prop('checked')) {
        return;
      }
    }
    var match = name.match(/^properties\[(.+)\]$/);
    if (!match) {
      return;
    }
    var val = $el.val();
    properties[match[1]] = val == null ? '' : String(val);
  });
  return properties;
};

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productThumbs: '[data-product-single-thumbnail]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    singleOptionSelector: '[data-single-option-selector]',
    addToCartForm: '[data-add-to-cart-form]',
    cartCount: '[data-cart-count]',
    yotpoRatingStarsContainer: '[data-yotpo-star-ratings-container]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));

    slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
    this.init();
    this.initVariants();
    this.initImageToggle();
    this.showProductStarRating();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    init: function() {
      var self = this;
      $('.add-upsell').on("click", function(e) {
        e.preventDefault();
        let productEl = $(e.target.parentElement).find('input');
        productEl[0].checked = "checked";
        let productId = productEl.val();
        let done = () => {
          $('.cart-add-success').fadeIn().delay(2000).fadeOut();
          const currentCartCountNum = parseInt($(selectors.cartCount).first().text());
          $(selectors.cartCount).text(currentCartCountNum + 1);
          $('#CartDrawerB').click( );
          $.fancybox.close()
        }
        self.addToCart({id: productId}, done);
        return false;
      })
      $(selectors.addToCart, this.$container).on("click", function(e){
        if(e) e.preventDefault();
        var qty = 0;
        var anchor = this;
        $(anchor).prop("disabled", true);
        var form = $(selectors.addToCartForm, self.$container);
        var qtyToAdd = parseInt(form.find("[name='quantity']").val());

        currentCartCountNum = parseInt($(selectors.cartCount).first().text());

        var data = {
          id: form.find("[name='id']").val(),
          quantity: qtyToAdd
        };

        var lineProperties = theme.getLineItemPropertiesFromForm(form);
        if (Object.keys(lineProperties).length) {
          data.properties = lineProperties;
        }

        function done() {
          $(anchor).prop("disabled", false);
          $('.cart-add-success').fadeIn().delay(2000).fadeOut();
          $(selectors.cartCount).text(currentCartCountNum + qty);
          $('#CartDrawerB').click();
          $.fancybox.close()
        }
        var upsell = $.grep(form.find("[name='ids[]']"), function(el) {
            return $(el).is(":checked");
        });
        self.addToCart(data, function() {
          qty = qtyToAdd;

          var variant = $.grep(self.productSingleObject.variants, function(v){
            return v.id == data.id
          });

//           slate.tealium.addToCart(variant[0], self.productSingleObject.title, qty);

          if(upsell.length) {
              self.addToCart({id: upsell[0].value}, function() {
                qty++;
                if(upsell.length > 1)         {
                  self.addToCart({id: upsell[1].value}, function() {
                    qty++;
                    done();
                  });
                } else {
                  done();
                }
              });
          } else {
            done();
          }
        });
      });
    },
    addToCart: function(data, cb) {
        data = $.extend({}, {
          quantity: 1
        }, data);
        return $.post('/cart/add.js', data, cb, 'json');
    },
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    },
    initImageToggle: function() {
      if ($(selectors.productThumbs).length) {
        $(selectors.productThumbs).on("click", function(evt) {
          evt.preventDefault();
          var imgSrc = $(this).attr("data-product-image-large");
          Product.prototype.toggleFeaturedImage(imgSrc);
        });
      }
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;
      const fixedATCbutton = $('#fixed-add-to-cart-button');
      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        fixedATCbutton.removeClass('btn-disabled');
        fixedATCbutton.attr('onclick', '');
        fixedATCbutton.html(theme.strings.addToCart);
        $(selectors.addToCartText, this.$container).parent().removeClass('btn-disabled');
        $(selectors.addToCartText, this.$container).parent().removeAttr('disabled');
        $(selectors.addToCartText, this.$container).parent().attr('onclick', '');
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        fixedATCbutton.addClass('btn-disabled');
        fixedATCbutton.attr('onclick', 'openKlaviyoPDPBisPopup(this); return false;');
        fixedATCbutton.html(theme.strings.soldOut);
        $(selectors.addToCartText, this.$container).parent().addClass('btn-disabled');
        $(selectors.addToCartText, this.$container).parent().attr('onclick', 'openKlaviyoPDPBisPopup(this); return false;');
        $(selectors.addToCartText, this.$container).parent().removeAttr('disabled');
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);
    },
    toggleFeaturedImage: function(imgSrc) {
      $(selectors.productFeaturedImage).attr('src', imgSrc);
    },
    /**
     * Show Yotpo product star rating below proudct price
     */
    showProductStarRating: function() {
      setTimeout(function() {
        if(!$("[data-yotpo-star-ratings-container]").find(".yotpo-stars > span").first().hasClass('yotpo-icon-empty-star')) {
          $(selectors.yotpoRatingStarsContainer).show();
        }
      }, 2000);
    },
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Modal template.
 *
   * @namespace cart
 */

theme.Cart = (function() {
    var selectors = {
        removeCartItem: '[data-remove-cart-item]',
        updateCartItem: '[data-update-cart-item]',
        cartJson: '[data-cart-json]'
    };

    function Cart(container) {
        this.$container = $(container);

        this.cartObject = JSON.parse($(selectors.cartJson, this.$container).html());

        this.init();
        this.namespace = '.cart';
    }

   Cart.prototype = $.extend({}, Cart.prototype, {
    init: function() {
      var self = this;
      $(selectors.removeCartItem).on("click", function(e){
        setTimeout(function () {
          window.location.reload(); //reload page
       }, 500);

        var lineNumber = $(this).data('line-item');
        var item = self.cartObject.items[lineNumber];
//         slate.tealium.removeCartItem(item);
      });
    },
      /**
       * Event callback for Theme Editor `section:unload` event
       */
      onUnload: function() {
        this.$container.off(this.namespace);
      },
      onSelect: function(e,x) {
      }
    });

   return Cart;
})();



theme.BackToTop = (function() {

      function BackToTop(container) {
        this.$container = $(container);
        this.namespace = '.backtotop';
        this.init();
      }

      BackToTop.prototype = $.extend({}, BackToTop.prototype, {

        /**
         * Handles change events from the variant inputs
         */
        init: function() {
            var self = this;
            self.$container.on("click", function(e){
                if (e) e.preventDefault();
                var top = 0,
                    hash = $(this).attr("href") || $(this).data("target") || "#",
                    offset = $(this).data("offset") || 0,
                    expand = $(this).data("expand") || false,
                    expandTarget = $(this).data("expand-target") || hash,
                    speed = parseInt($(this).data("speed")) || 500;
                if (hash && hash != "#") {
                    top = $(hash).position().top + offset;
                }
                $("body,html").animate({ scrollTop: top }, speed, function () {
                    if (expand) {
                        $(expandTarget).collapse("show");
                    }
                });
            });
            // back to top debounce method
            function backToTop() {
                if (window.scrollY == 0) {
                    self.$container.fadeOut();
                }
                else {
                    self.$container.fadeIn();
                }
            }

            $(window).on("scroll.backtotop", function () { $.doTimeout(100, backToTop) });

        },
        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function() {
          this.$container.off(this.namespace);
        }
      });

      return BackToTop;
    })();


/**
 * ----------------------------------------------------------------------------------------------------
 * FANCYBOX
 * ----------------------------------------------------------------------------------------------------
 */
  (function(r,G,f,v){var J=f("html"),n=f(r),p=f(G),b=f.fancybox=function(){b.open.apply(this,arguments)},I=navigator.userAgent.match(/msie/i),B=null,s=G.createTouch!==v,t=function(a){return a&&a.hasOwnProperty&&a instanceof f},q=function(a){return a&&"string"===f.type(a)},E=function(a){return q(a)&&0<a.indexOf("%")},l=function(a,d){var e=parseInt(a,10)||0;d&&E(a)&&(e*=b.getViewport()[d]/100);return Math.ceil(e)},w=function(a,b){return l(a,b)+"px"};f.extend(b,{version:"2.1.5",defaults:{padding:15,margin:20,
width:800,height:600,minWidth:100,minHeight:100,maxWidth:9999,maxHeight:9999,pixelRatio:1,autoSize:!0,autoHeight:!1,autoWidth:!1,autoResize:!0,autoCenter:!s,fitToView:!0,aspectRatio:!1,topRatio:0.5,leftRatio:0.5,scrolling:"auto",wrapCSS:"",arrows:!0,closeBtn:!0,closeClick:!1,nextClick:!1,mouseWheel:!0,autoPlay:!1,playSpeed:3E3,preload:3,modal:!1,loop:!0,ajax:{dataType:"html",headers:{"X-fancyBox":!0}},iframe:{scrolling:"auto",preload:!0},swf:{wmode:"transparent",allowfullscreen:"true",allowscriptaccess:"always"},
keys:{next:{13:"left",34:"up",39:"left",40:"up"},prev:{8:"right",33:"down",37:"right",38:"down"},close:[27],play:[32],toggle:[70]},direction:{next:"left",prev:"right"},scrollOutside:!0,index:0,type:null,href:null,content:null,title:null,tpl:{wrap:'<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',image:'<img class="fancybox-image" src="{href}" alt="" />',iframe:'<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen'+
(I?' allowtransparency="true"':"")+"></iframe>",error:'<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',closeBtn:'<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',next:'<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',prev:'<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'},openEffect:"fade",openSpeed:250,openEasing:"swing",openOpacity:!0,
openMethod:"zoomIn",closeEffect:"fade",closeSpeed:250,closeEasing:"swing",closeOpacity:!0,closeMethod:"zoomOut",nextEffect:"elastic",nextSpeed:250,nextEasing:"swing",nextMethod:"changeIn",prevEffect:"elastic",prevSpeed:250,prevEasing:"swing",prevMethod:"changeOut",helpers:{overlay:!0,title:!0},onCancel:f.noop,beforeLoad:f.noop,afterLoad:f.noop,beforeShow:f.noop,afterShow:f.noop,beforeChange:f.noop,beforeClose:f.noop,afterClose:f.noop},group:{},opts:{},previous:null,coming:null,current:null,isActive:!1,
isOpen:!1,isOpened:!1,wrap:null,skin:null,outer:null,inner:null,player:{timer:null,isActive:!1},ajaxLoad:null,imgPreload:null,transitions:{},helpers:{},open:function(a,d){if(a&&(f.isPlainObject(d)||(d={}),!1!==b.close(!0)))return f.isArray(a)||(a=t(a)?f(a).get():[a]),f.each(a,function(e,c){var k={},g,h,j,m,l;"object"===f.type(c)&&(c.nodeType&&(c=f(c)),t(c)?(k={href:c.data("fancybox-href")||c.attr("href"),title:c.data("fancybox-title")||c.attr("title"),isDom:!0,element:c},f.metadata&&f.extend(!0,k,
c.metadata())):k=c);g=d.href||k.href||(q(c)?c:null);h=d.title!==v?d.title:k.title||"";m=(j=d.content||k.content)?"html":d.type||k.type;!m&&k.isDom&&(m=c.data("fancybox-type"),m||(m=(m=c.prop("class").match(/fancybox\.(\w+)/))?m[1]:null));q(g)&&(m||(b.isImage(g)?m="image":b.isSWF(g)?m="swf":"#"===g.charAt(0)?m="inline":q(c)&&(m="html",j=c)),"ajax"===m&&(l=g.split(/\s+/,2),g=l.shift(),l=l.shift()));j||("inline"===m?g?j=f(q(g)?g.replace(/.*(?=#[^\s]+$)/,""):g):k.isDom&&(j=c):"html"===m?j=g:!m&&(!g&&
k.isDom)&&(m="inline",j=c));f.extend(k,{href:g,type:m,content:j,title:h,selector:l});a[e]=k}),b.opts=f.extend(!0,{},b.defaults,d),d.keys!==v&&(b.opts.keys=d.keys?f.extend({},b.defaults.keys,d.keys):!1),b.group=a,b._start(b.opts.index)},cancel:function(){var a=b.coming;a&&!1!==b.trigger("onCancel")&&(b.hideLoading(),b.ajaxLoad&&b.ajaxLoad.abort(),b.ajaxLoad=null,b.imgPreload&&(b.imgPreload.onload=b.imgPreload.onerror=null),a.wrap&&a.wrap.stop(!0,!0).trigger("onReset").remove(),b.coming=null,b.current||
b._afterZoomOut(a))},close:function(a){b.cancel();!1!==b.trigger("beforeClose")&&(b.unbindEvents(),b.isActive&&(!b.isOpen||!0===a?(f(".fancybox-wrap").stop(!0).trigger("onReset").remove(),b._afterZoomOut()):(b.isOpen=b.isOpened=!1,b.isClosing=!0,f(".fancybox-item, .fancybox-nav").remove(),b.wrap.stop(!0,!0).removeClass("fancybox-opened"),b.transitions[b.current.closeMethod]())))},play:function(a){var d=function(){clearTimeout(b.player.timer)},e=function(){d();b.current&&b.player.isActive&&(b.player.timer=
setTimeout(b.next,b.current.playSpeed))},c=function(){d();p.unbind(".player");b.player.isActive=!1;b.trigger("onPlayEnd")};if(!0===a||!b.player.isActive&&!1!==a){if(b.current&&(b.current.loop||b.current.index<b.group.length-1))b.player.isActive=!0,p.bind({"onCancel.player beforeClose.player":c,"onUpdate.player":e,"beforeLoad.player":d}),e(),b.trigger("onPlayStart")}else c()},next:function(a){var d=b.current;d&&(q(a)||(a=d.direction.next),b.jumpto(d.index+1,a,"next"))},prev:function(a){var d=b.current;
d&&(q(a)||(a=d.direction.prev),b.jumpto(d.index-1,a,"prev"))},jumpto:function(a,d,e){var c=b.current;c&&(a=l(a),b.direction=d||c.direction[a>=c.index?"next":"prev"],b.router=e||"jumpto",c.loop&&(0>a&&(a=c.group.length+a%c.group.length),a%=c.group.length),c.group[a]!==v&&(b.cancel(),b._start(a)))},reposition:function(a,d){var e=b.current,c=e?e.wrap:null,k;c&&(k=b._getPosition(d),a&&"scroll"===a.type?(delete k.position,c.stop(!0,!0).animate(k,200)):(c.css(k),e.pos=f.extend({},e.dim,k)))},update:function(a){var d=
    a&&a.type,e=!d||"orientationchange"===d;e&&(clearTimeout(B),B=null);b.isOpen&&!B&&(B=setTimeout(function(){var c=b.current;c&&!b.isClosing&&(b.wrap.removeClass("fancybox-tmp"),(e||"load"===d||"resize"===d&&c.autoResize)&&b._setDimension(),"scroll"===d&&c.canShrink||b.reposition(a),b.trigger("onUpdate"),B=null)},e&&!s?0:300))},toggle:function(a){b.isOpen&&(b.current.fitToView="boolean"===f.type(a)?a:!b.current.fitToView,s&&(b.wrap.removeAttr("style").addClass("fancybox-tmp"),b.trigger("onUpdate")),
b.update())},hideLoading:function(){p.unbind(".loading");f("#fancybox-loading").remove()},showLoading:function(){var a,d;b.hideLoading();a=f('<div id="fancybox-loading"><div></div></div>').click(b.cancel).appendTo("body");p.bind("keydown.loading",function(a){if(27===(a.which||a.keyCode))a.preventDefault(),b.cancel()});b.defaults.fixed||(d=b.getViewport(),a.css({position:"absolute",top:0.5*d.h+d.y,left:0.5*d.w+d.x}))},getViewport:function(){var a=b.current&&b.current.locked||!1,d={x:n.scrollLeft(),
y:n.scrollTop()};a?(d.w=a[0].clientWidth,d.h=a[0].clientHeight):(d.w=s&&r.innerWidth?r.innerWidth:n.width(),d.h=s&&r.innerHeight?r.innerHeight:n.height());return d},unbindEvents:function(){b.wrap&&t(b.wrap)&&b.wrap.unbind(".fb");p.unbind(".fb");n.unbind(".fb")},bindEvents:function(){var a=b.current,d;a&&(n.bind("orientationchange.fb"+(s?"":" resize.fb")+(a.autoCenter&&!a.locked?" scroll.fb":""),b.update),(d=a.keys)&&p.bind("keydown.fb",function(e){var c=e.which||e.keyCode,k=e.target||e.srcElement;
if(27===c&&b.coming)return!1;!e.ctrlKey&&(!e.altKey&&!e.shiftKey&&!e.metaKey&&(!k||!k.type&&!f(k).is("[contenteditable]")))&&f.each(d,function(d,k){if(1<a.group.length&&k[c]!==v)return b[d](k[c]),e.preventDefault(),!1;if(-1<f.inArray(c,k))return b[d](),e.preventDefault(),!1})}),f.fn.mousewheel&&a.mouseWheel&&b.wrap.bind("mousewheel.fb",function(d,c,k,g){for(var h=f(d.target||null),j=!1;h.length&&!j&&!h.is(".fancybox-skin")&&!h.is(".fancybox-wrap");)j=h[0]&&!(h[0].style.overflow&&"hidden"===h[0].style.overflow)&&
  (h[0].clientWidth&&h[0].scrollWidth>h[0].clientWidth||h[0].clientHeight&&h[0].scrollHeight>h[0].clientHeight),h=f(h).parent();if(0!==c&&!j&&1<b.group.length&&!a.canShrink){if(0<g||0<k)b.prev(0<g?"down":"left");else if(0>g||0>k)b.next(0>g?"up":"right");d.preventDefault()}}))},trigger:function(a,d){var e,c=d||b.coming||b.current;if(c){f.isFunction(c[a])&&(e=c[a].apply(c,Array.prototype.slice.call(arguments,1)));if(!1===e)return!1;c.helpers&&f.each(c.helpers,function(d,e){if(e&&b.helpers[d]&&f.isFunction(b.helpers[d][a]))b.helpers[d][a](f.extend(!0,
{},b.helpers[d].defaults,e),c)});p.trigger(a)}},isImage:function(a){return q(a)&&a.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)},isSWF:function(a){return q(a)&&a.match(/\.(swf)((\?|#).*)?$/i)},_start:function(a){var d={},e,c;a=l(a);e=b.group[a]||null;if(!e)return!1;d=f.extend(!0,{},b.opts,e);e=d.margin;c=d.padding;"number"===f.type(e)&&(d.margin=[e,e,e,e]);"number"===f.type(c)&&(d.padding=[c,c,c,c]);d.modal&&f.extend(!0,d,{closeBtn:!1,closeClick:!1,nextClick:!1,arrows:!1,
mouseWheel:!1,keys:null,helpers:{overlay:{closeClick:!1}}});d.autoSize&&(d.autoWidth=d.autoHeight=!0);"auto"===d.width&&(d.autoWidth=!0);"auto"===d.height&&(d.autoHeight=!0);d.group=b.group;d.index=a;b.coming=d;if(!1===b.trigger("beforeLoad"))b.coming=null;else{c=d.type;e=d.href;if(!c)return b.coming=null,b.current&&b.router&&"jumpto"!==b.router?(b.current.index=a,b[b.router](b.direction)):!1;b.isActive=!0;if("image"===c||"swf"===c)d.autoHeight=d.autoWidth=!1,d.scrolling="visible";"image"===c&&(d.aspectRatio=
!0);"iframe"===c&&s&&(d.scrolling="scroll");d.wrap=f(d.tpl.wrap).addClass("fancybox-"+(s?"mobile":"desktop")+" fancybox-type-"+c+" fancybox-tmp "+d.wrapCSS).appendTo(d.parent||"body");f.extend(d,{skin:f(".fancybox-skin",d.wrap),outer:f(".fancybox-outer",d.wrap),inner:f(".fancybox-inner",d.wrap)});f.each(["Top","Right","Bottom","Left"],function(a,b){d.skin.css("padding"+b,w(d.padding[a]))});b.trigger("onReady");if("inline"===c||"html"===c){if(!d.content||!d.content.length)return b._error("content")}else if(!e)return b._error("href");
"image"===c?b._loadImage():"ajax"===c?b._loadAjax():"iframe"===c?b._loadIframe():b._afterLoad()}},_error:function(a){f.extend(b.coming,{type:"html",autoWidth:!0,autoHeight:!0,minWidth:0,minHeight:0,scrolling:"no",hasError:a,content:b.coming.tpl.error});b._afterLoad()},_loadImage:function(){var a=b.imgPreload=new Image;a.onload=function(){this.onload=this.onerror=null;b.coming.width=this.width/b.opts.pixelRatio;b.coming.height=this.height/b.opts.pixelRatio;b._afterLoad()};a.onerror=function(){this.onload=
  this.onerror=null;b._error("image")};a.src=b.coming.href;!0!==a.complete&&b.showLoading()},_loadAjax:function(){var a=b.coming;b.showLoading();b.ajaxLoad=f.ajax(f.extend({},a.ajax,{url:a.href,error:function(a,e){b.coming&&"abort"!==e?b._error("ajax",a):b.hideLoading()},success:function(d,e){"success"===e&&(a.content=d,b._afterLoad())}}))},_loadIframe:function(){var a=b.coming,d=f(a.tpl.iframe.replace(/\{rnd\}/g,(new Date).getTime())).attr("scrolling",s?"auto":a.iframe.scrolling).attr("src",a.href);
f(a.wrap).bind("onReset",function(){try{f(this).find("iframe").hide().attr("src","//about:blank").end().empty()}catch(a){}});a.iframe.preload&&(b.showLoading(),d.one("load",function(){f(this).data("ready",1);s||f(this).bind("load.fb",b.update);f(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show();b._afterLoad()}));a.content=d.appendTo(a.inner);a.iframe.preload||b._afterLoad()},_preloadImages:function(){var a=b.group,d=b.current,e=a.length,c=d.preload?Math.min(d.preload,
e-1):0,f,g;for(g=1;g<=c;g+=1)f=a[(d.index+g)%e],"image"===f.type&&f.href&&((new Image).src=f.href)},_afterLoad:function(){var a=b.coming,d=b.current,e,c,k,g,h;b.hideLoading();if(a&&!1!==b.isActive)if(!1===b.trigger("afterLoad",a,d))a.wrap.stop(!0).trigger("onReset").remove(),b.coming=null;else{d&&(b.trigger("beforeChange",d),d.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove());b.unbindEvents();e=a.content;c=a.type;k=a.scrolling;f.extend(b,{wrap:a.wrap,skin:a.skin,
outer:a.outer,inner:a.inner,current:a,previous:d});g=a.href;switch(c){case "inline":case "ajax":case "html":a.selector?e=f("<div>").html(e).find(a.selector):t(e)&&(e.data("fancybox-placeholder")||e.data("fancybox-placeholder",f('<div class="fancybox-placeholder"></div>').insertAfter(e).hide()),e=e.show().detach(),a.wrap.bind("onReset",function(){f(this).find(e).length&&e.hide().replaceAll(e.data("fancybox-placeholder")).data("fancybox-placeholder",!1)}));break;case "image":e=a.tpl.image.replace("{href}",
g);break;case "swf":e='<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="'+g+'"></param>',h="",f.each(a.swf,function(a,b){e+='<param name="'+a+'" value="'+b+'"></param>';h+=" "+a+'="'+b+'"'}),e+='<embed src="'+g+'" type="application/x-shockwave-flash" width="100%" height="100%"'+h+"></embed></object>"}(!t(e)||!e.parent().is(a.inner))&&a.inner.append(e);b.trigger("beforeShow");a.inner.css("overflow","yes"===k?"scroll":
"no"===k?"hidden":k);b._setDimension();b.reposition();b.isOpen=!1;b.coming=null;b.bindEvents();if(b.isOpened){if(d.prevMethod)b.transitions[d.prevMethod]()}else f(".fancybox-wrap").not(a.wrap).stop(!0).trigger("onReset").remove();b.transitions[b.isOpened?a.nextMethod:a.openMethod]();b._preloadImages()}},_setDimension:function(){var a=b.getViewport(),d=0,e=!1,c=!1,e=b.wrap,k=b.skin,g=b.inner,h=b.current,c=h.width,j=h.height,m=h.minWidth,u=h.minHeight,n=h.maxWidth,p=h.maxHeight,s=h.scrolling,q=h.scrollOutside?
  h.scrollbarWidth:0,x=h.margin,y=l(x[1]+x[3]),r=l(x[0]+x[2]),v,z,t,C,A,F,B,D,H;e.add(k).add(g).width("auto").height("auto").removeClass("fancybox-tmp");x=l(k.outerWidth(!0)-k.width());v=l(k.outerHeight(!0)-k.height());z=y+x;t=r+v;C=E(c)?(a.w-z)*l(c)/100:c;A=E(j)?(a.h-t)*l(j)/100:j;if("iframe"===h.type){if(H=h.content,h.autoHeight&&1===H.data("ready"))try{H[0].contentWindow.document.location&&(g.width(C).height(9999),F=H.contents().find("body"),q&&F.css("overflow-x","hidden"),A=F.outerHeight(!0))}catch(G){}}else if(h.autoWidth||
h.autoHeight)g.addClass("fancybox-tmp"),h.autoWidth||g.width(C),h.autoHeight||g.height(A),h.autoWidth&&(C=g.width()),h.autoHeight&&(A=g.height()),g.removeClass("fancybox-tmp");c=l(C);j=l(A);D=C/A;m=l(E(m)?l(m,"w")-z:m);n=l(E(n)?l(n,"w")-z:n);u=l(E(u)?l(u,"h")-t:u);p=l(E(p)?l(p,"h")-t:p);F=n;B=p;h.fitToView&&(n=Math.min(a.w-z,n),p=Math.min(a.h-t,p));z=a.w-y;r=a.h-r;h.aspectRatio?(c>n&&(c=n,j=l(c/D)),j>p&&(j=p,c=l(j*D)),c<m&&(c=m,j=l(c/D)),j<u&&(j=u,c=l(j*D))):(c=Math.max(m,Math.min(c,n)),h.autoHeight&&
"iframe"!==h.type&&(g.width(c),j=g.height()),j=Math.max(u,Math.min(j,p)));if(h.fitToView)if(g.width(c).height(j),e.width(c+x),a=e.width(),y=e.height(),h.aspectRatio)for(;(a>z||y>r)&&(c>m&&j>u)&&!(19<d++);)j=Math.max(u,Math.min(p,j-10)),c=l(j*D),c<m&&(c=m,j=l(c/D)),c>n&&(c=n,j=l(c/D)),g.width(c).height(j),e.width(c+x),a=e.width(),y=e.height();else c=Math.max(m,Math.min(c,c-(a-z))),j=Math.max(u,Math.min(j,j-(y-r)));q&&("auto"===s&&j<A&&c+x+q<z)&&(c+=q);g.width(c).height(j);e.width(c+x);a=e.width();
y=e.height();e=(a>z||y>r)&&c>m&&j>u;c=h.aspectRatio?c<F&&j<B&&c<C&&j<A:(c<F||j<B)&&(c<C||j<A);f.extend(h,{dim:{width:w(a),height:w(y)},origWidth:C,origHeight:A,canShrink:e,canExpand:c,wPadding:x,hPadding:v,wrapSpace:y-k.outerHeight(!0),skinSpace:k.height()-j});!H&&(h.autoHeight&&j>u&&j<p&&!c)&&g.height("auto")},_getPosition:function(a){var d=b.current,e=b.getViewport(),c=d.margin,f=b.wrap.width()+c[1]+c[3],g=b.wrap.height()+c[0]+c[2],c={position:"absolute",top:c[0],left:c[3]};d.autoCenter&&d.fixed&&
  !a&&g<=e.h&&f<=e.w?c.position="fixed":d.locked||(c.top+=e.y,c.left+=e.x);c.top=w(Math.max(c.top,c.top+(e.h-g)*d.topRatio));c.left=w(Math.max(c.left,c.left+(e.w-f)*d.leftRatio));return c},_afterZoomIn:function(){var a=b.current;a&&(b.isOpen=b.isOpened=!0,b.wrap.css("overflow","visible").addClass("fancybox-opened"),b.update(),(a.closeClick||a.nextClick&&1<b.group.length)&&b.inner.css("cursor","pointer").bind("click.fb",function(d){!f(d.target).is("a")&&!f(d.target).parent().is("a")&&(d.preventDefault(),
b[a.closeClick?"close":"next"]())}),a.closeBtn&&f(a.tpl.closeBtn).appendTo(b.skin).bind("click.fb",function(a){a.preventDefault();b.close()}),a.arrows&&1<b.group.length&&((a.loop||0<a.index)&&f(a.tpl.prev).appendTo(b.outer).bind("click.fb",b.prev),(a.loop||a.index<b.group.length-1)&&f(a.tpl.next).appendTo(b.outer).bind("click.fb",b.next)),b.trigger("afterShow"),!a.loop&&a.index===a.group.length-1?b.play(!1):b.opts.autoPlay&&!b.player.isActive&&(b.opts.autoPlay=!1,b.play()))},_afterZoomOut:function(a){a=
  a||b.current;f(".fancybox-wrap").trigger("onReset").remove();f.extend(b,{group:{},opts:{},router:!1,current:null,isActive:!1,isOpened:!1,isOpen:!1,isClosing:!1,wrap:null,skin:null,outer:null,inner:null});b.trigger("afterClose",a)}});b.transitions={getOrigPosition:function(){var a=b.current,d=a.element,e=a.orig,c={},f=50,g=50,h=a.hPadding,j=a.wPadding,m=b.getViewport();!e&&(a.isDom&&d.is(":visible"))&&(e=d.find("img:first"),e.length||(e=d));t(e)?(c=e.offset(),e.is("img")&&(f=e.outerWidth(),g=e.outerHeight())):
  (c.top=m.y+(m.h-g)*a.topRatio,c.left=m.x+(m.w-f)*a.leftRatio);if("fixed"===b.wrap.css("position")||a.locked)c.top-=m.y,c.left-=m.x;return c={top:w(c.top-h*a.topRatio),left:w(c.left-j*a.leftRatio),width:w(f+j),height:w(g+h)}},step:function(a,d){var e,c,f=d.prop;c=b.current;var g=c.wrapSpace,h=c.skinSpace;if("width"===f||"height"===f)e=d.end===d.start?1:(a-d.start)/(d.end-d.start),b.isClosing&&(e=1-e),c="width"===f?c.wPadding:c.hPadding,c=a-c,b.skin[f](l("width"===f?c:c-g*e)),b.inner[f](l("width"===
f?c:c-g*e-h*e))},zoomIn:function(){var a=b.current,d=a.pos,e=a.openEffect,c="elastic"===e,k=f.extend({opacity:1},d);delete k.position;c?(d=this.getOrigPosition(),a.openOpacity&&(d.opacity=0.1)):"fade"===e&&(d.opacity=0.1);b.wrap.css(d).animate(k,{duration:"none"===e?0:a.openSpeed,easing:a.openEasing,step:c?this.step:null,complete:b._afterZoomIn})},zoomOut:function(){var a=b.current,d=a.closeEffect,e="elastic"===d,c={opacity:0.1};e&&(c=this.getOrigPosition(),a.closeOpacity&&(c.opacity=0.1));b.wrap.animate(c,
{duration:"none"===d?0:a.closeSpeed,easing:a.closeEasing,step:e?this.step:null,complete:b._afterZoomOut})},changeIn:function(){var a=b.current,d=a.nextEffect,e=a.pos,c={opacity:1},f=b.direction,g;e.opacity=0.1;"elastic"===d&&(g="down"===f||"up"===f?"top":"left","down"===f||"right"===f?(e[g]=w(l(e[g])-200),c[g]="+=200px"):(e[g]=w(l(e[g])+200),c[g]="-=200px"));"none"===d?b._afterZoomIn():b.wrap.css(e).animate(c,{duration:a.nextSpeed,easing:a.nextEasing,complete:b._afterZoomIn})},changeOut:function(){var a=
      b.previous,d=a.prevEffect,e={opacity:0.1},c=b.direction;"elastic"===d&&(e["down"===c||"up"===c?"top":"left"]=("up"===c||"left"===c?"-":"+")+"=200px");a.wrap.animate(e,{duration:"none"===d?0:a.prevSpeed,easing:a.prevEasing,complete:function(){f(this).trigger("onReset").remove()}})}};b.helpers.overlay={defaults:{closeClick:!0,speedOut:200,showEarly:!0,css:{},locked:!s,fixed:!0},overlay:null,fixed:!1,el:f("html"),create:function(a){a=f.extend({},this.defaults,a);this.overlay&&this.close();this.overlay=
        f('<div class="fancybox-overlay"></div>').appendTo(b.coming?b.coming.parent:a.parent);this.fixed=!1;a.fixed&&b.defaults.fixed&&(this.overlay.addClass("fancybox-overlay-fixed"),this.fixed=!0)},open:function(a){var d=this;a=f.extend({},this.defaults,a);this.overlay?this.overlay.unbind(".overlay").width("auto").height("auto"):this.create(a);this.fixed||(n.bind("resize.overlay",f.proxy(this.update,this)),this.update());a.closeClick&&this.overlay.bind("click.overlay",function(a){if(f(a.target).hasClass("fancybox-overlay"))return b.isActive?
        b.close():d.close(),!1});this.overlay.css(a.css).show()},close:function(){var a,b;n.unbind("resize.overlay");this.el.hasClass("fancybox-lock")&&(f(".fancybox-margin").removeClass("fancybox-margin"),a=n.scrollTop(),b=n.scrollLeft(),this.el.removeClass("fancybox-lock"),n.scrollTop(a).scrollLeft(b));f(".fancybox-overlay").remove().hide();f.extend(this,{overlay:null,fixed:!1})},update:function(){var a="100%",b;this.overlay.width(a).height("100%");I?(b=Math.max(G.documentElement.offsetWidth,G.body.offsetWidth),
p.width()>b&&(a=p.width())):p.width()>n.width()&&(a=p.width());this.overlay.width(a).height(p.height())},onReady:function(a,b){var e=this.overlay;f(".fancybox-overlay").stop(!0,!0);e||this.create(a);a.locked&&(this.fixed&&b.fixed)&&(e||(this.margin=p.height()>n.height()?f("html").css("margin-right").replace("px",""):!1),b.locked=this.overlay.append(b.wrap),b.fixed=!1);!0===a.showEarly&&this.beforeShow.apply(this,arguments)},beforeShow:function(a,b){var e,c;b.locked&&(!1!==this.margin&&(f("*").filter(function(){return"fixed"===
        f(this).css("position")&&!f(this).hasClass("fancybox-overlay")&&!f(this).hasClass("fancybox-wrap")}).addClass("fancybox-margin"),this.el.addClass("fancybox-margin")),e=n.scrollTop(),c=n.scrollLeft(),this.el.addClass("fancybox-lock"),n.scrollTop(e).scrollLeft(c));this.open(a)},onUpdate:function(){this.fixed||this.update()},afterClose:function(a){this.overlay&&!b.coming&&this.overlay.fadeOut(a.speedOut,f.proxy(this.close,this))}};b.helpers.title={defaults:{type:"float",position:"bottom"},beforeShow:function(a){var d=
          b.current,e=d.title,c=a.type;f.isFunction(e)&&(e=e.call(d.element,d));if(q(e)&&""!==f.trim(e)){d=f('<div class="fancybox-title fancybox-title-'+c+'-wrap">'+e+"</div>");switch(c){case "inside":c=b.skin;break;case "outside":c=b.wrap;break;case "over":c=b.inner;break;default:c=b.skin,d.appendTo("body"),I&&d.width(d.width()),d.wrapInner('<span class="child"></span>'),b.current.margin[2]+=Math.abs(l(d.css("margin-bottom")))}d["top"===a.position?"prependTo":"appendTo"](c)}}};f.fn.fancybox=function(a){var d,
              e=f(this),c=this.selector||"",k=function(g){var h=f(this).blur(),j=d,k,l;!g.ctrlKey&&(!g.altKey&&!g.shiftKey&&!g.metaKey)&&!h.is(".fancybox-wrap")&&(k=a.groupAttr||"data-fancybox-group",l=h.attr(k),l||(k="rel",l=h.get(0)[k]),l&&(""!==l&&"nofollow"!==l)&&(h=c.length?f(c):e,h=h.filter("["+k+'="'+l+'"]'),j=h.index(this)),a.index=j,!1!==b.open(h,a)&&g.preventDefault())};a=a||{};d=a.index||0;!c||!1===a.live?e.unbind("click.fb-start").bind("click.fb-start",k):p.undelegate(c,"click.fb-start").delegate(c+
":not('.fancybox-item, .fancybox-nav')","click.fb-start",k);this.filter("[data-fancybox-start=1]").trigger("click");return this};p.ready(function(){var a,d;f.scrollbarWidth===v&&(f.scrollbarWidth=function(){var a=f('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),b=a.children(),b=b.innerWidth()-b.height(99).innerWidth();a.remove();return b});if(f.support.fixedPosition===v){a=f.support;d=f('<div style="position:fixed;top:20px;"></div>').appendTo("body");var e=20===
                  d[0].offsetTop||15===d[0].offsetTop;d.remove();a.fixedPosition=e}f.extend(b.defaults,{scrollbarWidth:f.scrollbarWidth(),fixed:f.support.fixedPosition,parent:f("body")});a=f(r).width();J.addClass("fancybox-lock-test");d=f(r).width();J.removeClass("fancybox-lock-test");f("<style type='text/css'>.fancybox-margin{margin-right:"+(d-a)+"px;}</style>").appendTo("head")})})(window,document,jQuery);


/**
 * ----------------------------------------------------------------------------------------------------
 * Use Fancybox to Ajax in product quick view template
 * ----------------------------------------------------------------------------------------------------
 */

if ($(window).width() >= 980) {
  $('.product-index').hover(function(){
    $(this).children('.product-modal').show();
  }, function(){
    $(this).children('.product-modal').hide();
  })
  // Call Fancybox for product modal + stop scroll to top
  $('.product-modal').fancybox({
    afterShow: function () {
      var context = document.querySelector(".fancybox-opened");
      $('body').trigger('quickview:load',[context]);
      slate.init()
    },
    helpers: {
// 	  'showCloseButton': true,
      overlay: {
        locked: false
      }
    }
  });
}

$('body').on("quickview:load", function (event, container) {
  //container != null && theme.Product(container);
});

 /**
 * ----------------------------------------------------------------------------------------------------
 * Use Fancybox for any class of ....fancybox
 * ----------------------------------------------------------------------------------------------------
 */

  $(".fancybox").fancybox({
    helpers: {
      overlay: {
        locked: false
      }
    }
  });



/**
 * Slideshow Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Slideshow template.
 *
   * @namespace slideshow
 */

theme.Slideshow = (function() {
    /**
     * Slideshow section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Slideshow(container) {
      //alert("slideshow");
      this.$container = $(container);
      //var sectionId = this.$container.data('section-id');
      //alert(sectionId)
      //var $slideshow = $("#slideshow-" + sectionId)
      //$slideshow.slick('unslick');
      var opt = this.$container.data("slick");
      this.$container.slick(opt);
      this.namespace = '.slideshow';
    }

    Slideshow.prototype = $.extend({}, Slideshow.prototype, {
      /**
       * Event callback for Theme Editor `section:unload` event
       */
      onUnload: function() {
        this.$container.off(this.namespace);
      },
      onSelect: function() {
        //alert("onSelect");
          //var sectionId = this.$container.data('section-id');
        //alert(sectionId);
          //var $slideshow = $("#slideshow-" + sectionId);
          //$slideshow.slick('unslick');
          var opt = this.$container.data("slick");
          this.$container.slick(opt);
      }
    });

    return Slideshow;
  })();

theme.Collection = (function() {

      var selectors = {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productFeaturedImage: '[data-product-featured-image]',
        productJson: '[data-product-json]',
        productPrice: '[data-product-price]',
        productThumbs: '[data-product-single-thumbnail]',
        singleOptionSelector: '[data-single-option-selector]',
        cartCount: '[data-cart-count]',
        collectionForm: '[data-collection-item-form]'
      };

      /**
       * Product section constructor. Runs on page load as well as Theme Editor
       * `section:load` events.
       * @param {string} container - selector for the section container DOM element
       */
      function Collection(container) {
        this.$container = $(container);
        var sectionId = this.$container.attr('data-section-id');

        this.settings = {};
        this.namespace = '.collection';

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
          return;
        }

        this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
        this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));

        slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
        this.init();
        this.initVariants();
      }

      Collection.prototype = $.extend({}, Collection.prototype, {

        /**
         * Handles change events from the variant inputs
         */
        init: function() {
          var self = this;
          $(selectors.addToCart, this.$container).click(function(e) {
            if(e) e.preventDefault();
            var anchor = this;
            $(anchor).prop("disabled", true);
            var dataArr = $(selectors.collectionForm, self.$container).serializeArray();
            var data = {};
            $.each(dataArr, function(i, a) {
              data[a.name] = a.value;
            });
            self.addToCart(data, function() {
              $(anchor).prop("disabled", false);
              $('.cart-add-success', self.$container).fadeIn().delay(2000).fadeOut();
              var text = $(selectors.cartCount).first().text();
              var num = parseInt(text);
              $(selectors.cartCount).text(num + 1);
              $.fancybox.close();
              setTimeout(function(){
                console.log('here1');
                theme.cart.updateCart(data);
                theme.RightDrawer.open();
              },1);
            })
          });
        },
        addToCart: function(data, cb) {
            var self = this; //cart object
            data = $.extend({}, {
              quantity: 1
            }, data);
            $.post('/cart/add.js', data, cb, 'json');

            var variant = $.grep(self.productSingleObject.variants, function(v){
              return v.id == data.id
            });
//             slate.tealium.addToCart(variant[0], self.productSingleObject.title, data.quantity);
        },
        initVariants: function() {
          var options = {
            $container: this.$container,
            enableHistoryState: this.$container.data('enable-history-state') || false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: this.productSingleObject
          };

          this.variants = new slate.Variants(options);

          this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
          this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
          this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
        },

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function(evt) {
          var variant = evt.variant;

          if (variant) {
            $(selectors.priceWrapper, this.$container).removeClass('hide');
          } else {
            $(selectors.addToCart, this.$container).prop('disabled', true);
            $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
            $(selectors.priceWrapper, this.$container).addClass('hide');
            return;
          }

          if (variant.available) {
            $(selectors.addToCart, this.$container).prop('disabled', false);
            $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
          } else {
            $(selectors.addToCart, this.$container).prop('disabled', true);
            $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
          }
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function(evt) {
          var variant = evt.variant;
          var $comparePrice = $(selectors.comparePrice, this.$container);
          var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

          $(selectors.productPrice, this.$container)
            .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

          if (variant.compare_at_price > variant.price) {
            $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
            $compareEls.removeClass('hide');
          } else {
            $comparePrice.html('');
            $compareEls.addClass('hide');
          }
        },
        updateProductImage: function(evt) {
          var variant = evt.variant;
          var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

          $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);
        },
        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function() {
          this.$container.off(this.namespace);
        }
      });

      return Collection;
    })();
$(document).ready(function() {
    $('.grid-content-image').on('click', function(evt) {
        var w = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
        var isMobile = w < 768;
        var sectionId = '';

         if(isMobile) {
            sectionId = $(this).data('content-mobile-id');
          }
          else {
              sectionId = $(this).data('content-id');
          }

        $('.grid-content-copy').hide();
        $('#' + sectionId).fadeIn();

        $('html, body').animate({
            scrollTop: $('#' + sectionId).offset().top
        }, 500);
      });

    //Temp fix, this should be done using snippet or section
    $.getJSON('/cart.js', function(cart) {
        if(cart.item_count > 0 && $('[data-cart-count]').length)
        $('[data-cart-count]').html(cart.item_count);
    });

    $('.btn-load-more').on('click', this, function(evt) {
        var hiddenConent = $('.press-coverage-content').find($('.content-row:hidden'));
        var rowsLeftToShow = hiddenConent.length;

        if(rowsLeftToShow > 0){
        $(hiddenConent).first().fadeIn(function() {
            if(rowsLeftToShow == 1){
            $('.btn-load-more').hide();
            }
        });
        }
    });
});
theme.ScrollToVideo = (function() {
    var player;
    var selectors = {
        videoAnchor: '[data-video-anchor]',
        videoFrame: '[data-video-frame]',
        videoTrigger: '[data-video-trigger]'
    };

  function ScrollToVideo(container) {
    this.$container = $(container);
    this.namespace = '.scrolltovideo';
    this.init();
    this.includeYTScript();
  }

  ScrollToVideo.prototype = $.extend({}, ScrollToVideo.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    init: function() {
        var self = this;

        self.$container.on("click", function(e){
            if (e) e.preventDefault();
            var top = 0,
                hash = $(this).attr("href") || $(this).data("target") || "#",
                offset = $(this).data("offset") || 0,
                expand = $(this).data("expand") || false,
                expandTarget = $(this).data("expand-target") || hash,
                speed = parseInt($(this).data("speed")) || 500;
            if (hash && hash != "#") {
                top = $(hash).offset().top + offset;
            }
            $("body,html").animate({ scrollTop: top }, speed, function () {
               self.onYouTubePlayerAPIReady()
            });
        });


    },
    onYouTubePlayerAPIReady: function() {
        var self = this;
        // create the global player from the specific iframe (#video)
        player = new YT.Player('video-frame', {
            events: {
            // call this function when player is ready to use
            'onReady': self.onPlayerReady
            }
        });
    },
    onPlayerReady: function(event) {
        event.target.playVideo();
    },
    includeYTScript: function() {
        // Inject YouTube API script
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/player_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return ScrollToVideo;
})();
/**
 * Modal Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Modal template.
 *
   * @namespace modal
 */

theme.NewsletterModal = (function() {
  /**
   * Slideshow section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function NewsletterModal(container) {
    var self = this;
    this.$container = $(container);
    var $modalSettings = this.$container.data('modal');
    $modalSettings = $.extend({}, {
      items: {
        type: "inline",
        src: '#'+this.$container.attr("id")
      },
      callbacks: {
        open: function() {
          var email = $("#newsletter_email").val();
          var form = self.$container.find("[name='contact[email]']");
          form.val(email);
        }
      }
    }, $modalSettings);
    var trigger = this.$container.data('trigger');
    $(trigger).magnificPopup($modalSettings);
    this.namespace = '.modal';

    var newUser = getCookie("newsletter_isreturning");
    if(!newUser) {
      $(trigger).click();
      setCookie("newsletter_isreturning", "1");
    }
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }

  return NewsletterModal;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


slate.init = function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('cart', theme.Cart);
  sections.register('slideshow', theme.Slideshow);
  sections.register('collection', theme.Collection);
  sections.register('backtotop', theme.BackToTop);
  sections.register('videocta', theme.ScrollToVideo);
  sections.register('newslettermodal', theme.NewsletterModal);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
}

$(slate.init);




/* Based Theme Ajax Cart Import */




//Timber's drawer, more or less
// https://github.com/Shopify/Timber
// Source and Modifications to that source provided under the MIT license

//Simplify: don't need it to move the page over, doesn't need to to be directly clickable (though doing its own close is nice)

theme.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body'),//adds class
      page: $('#shopify-section-header') // listen to events
      ,moved: $('.is-moved-by-drawer') //shove this over by the width of the drawer.
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    //timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    //this.$nodes.moved.addClass('is-transitioning');//what does this do for me?
    //this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    //this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    var closer = $.proxy(function () {
      this.close();
      return false;
    }, this);
    //this.$nodes.page.on('click.drawer', closer);//force them to click the close button?
    $('#BgDrawer').on('click.drawer', closer);

    // Notify the drawer has opened
    //timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function (evt) {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    //timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    //this.$nodes.moved.prepareTransition({ disableExisting: true });
    //this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');
    $('#BgDrawer').off('.drawer');
    //remove sample modal once cart drawer closes
    $('#dialog-free').remove();
    // Notify the drawer is closed now
    //timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();
//oddly, Slate does not have the option for an ajax cart.

//need to add/remove items by ID (definitely not line number)
//update note
//update an assortment of numbers and settings on cart update
//update the cart
//broadcast on cart add (to add/remove specials), cart update (so anything else can see the new cart)

//options: copy the ID number edited timber cart?
// has handlebar
//Use the liquid cart html?
// no other libs, places limits on the actual cart, which, because there's a link on the checkout page, can not be removed.
// possibly slower in that it involves another call (BUT: timber was making an update.js/cart.js anyway)
//use react, because the rest of the site is also in react.
// rest of site not currently in react

//Ideally, all these functions also apply equally to the real /cart




/**
To react to cart changes:
$('body').on('cartupdate', function(cart) {
  $('#cartCount').text(cart.items.length);
  if (cart is not visible) {
    myCart.showCart();
  }
})

*/
theme.rsCart = (function(){
  function Cart(){
    this.cart = null;
  }

  /**
  opts is something like {id:123,quantity:1} or $('form').serialize()
  */
  Cart.prototype.addToCart = function(opts){
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: opts,
      dataType: 'json',
      success: function(cart) {
        this.cart = cart;
        $('body').trigger('cartupdate', cart);

      },
      error: function(XMLHttpRequest, textStatus) {
      },
      complete: function(jqxhr, text) {
      }
    })
  }

  Cart.prototype.removeFromCart = function(id){
    this.changeQuantity(id,0)
  }

  /**
  opts is something like {note:'note'} or "note=cart_notes_enable"
  */
  Cart.prototype.updateCart = function(opts){
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: opts,
      dataType: 'json',
      success: function(cart) {
        this.cart = cart;
        console.log('  Cart.prototype.updateCart');
        $('body').trigger('cartupdate', cart);
      },
      error: function(XMLHttpRequest, textStatus) {
      },
      complete: function(jqxhr, text) {
      }
    })
  }

  Cart.prototype.getCart = function() {
    return $.Deferred(function( dfd ) {
      if (this.cart != null) {
        return dfd.resolved(this.cart);
      }
      //not sure how you'd get a submit button without getting the cart set, but maybe?
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
          this.cart = cart;
          dfd.resolved(cart);
        },
        error: function(XMLHttpRequest, textStatus) {
        },
        complete: function(jqxhr, text) {
        }
      })
    })
  }

  Cart.prototype.gtm = function(event, cart, opts) {

    if (USE_DEFAULT_GTM) {
      dataLayer.push({
        'event': 'ecommerce_event',
        'eventCategory': 'ecommerce',
        'eventAction': event,
        'ecommerce': {
          'detail': {
            'new_cart': cart,
            'change': opts
          }
        }
      });
    }
  }
  /**
  id is cartItem.variant_id //TODO: //TEST: is on KA, but does that work with no variants?
  quant == 0 will remove the item from the cart
  */
  Cart.prototype.changeQuantity = function(id, quant){
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quant + '&id=' + id,
      dataType: 'json',
      success: function(cart) {
        this.cart = cart;
        $('body').trigger('cartupdate', cart);
      },
      error: function(XMLHttpRequest, textStatus) {
      },
      complete: function(jqxhr, text) {
      }
    })
  }

  var justRan = false;

  Cart.prototype.showCart = function(div){
    console.log("444446      url: '/cart?view=ajax',  ");

    $.ajax({
      type: 'GET',
      url: '/cart?view=ajax',
      success: function(html) {
        var cartTemplate = $(html).find('#cartTemplate');
        //If there is other random stuff that needs to added to the ajax cart html, add it here
        $(div).html(cartTemplate)
        $('.quantity', $(div)).each(function(i,o){theme.adjusters($(o))});
        if (!justRan && !cartUpdateCalledFromFree) {
          $.getJSON('/cart.js', function (cart) {
              runGWP(cart,rebuildCart); //rs-gwp-ultra
            });
        }
        cartUpdateCalledFromFree = false;
        justRan = false;
        /*
        The paypal button is present, but whatever code it needs is not running.
        Manually trigger it. It seems to be OK with running with no buttons to process.
        */
        Shopify.StorefrontExpressButtons.initialize();
      },
      error: function(XMLHttpRequest, textStatus) {
        $(div).html(textStatus)//shouldn't happen, but also doing  nothing is bad
      }
    })
  }

  return Cart;
})();

/**
intercept form submissions so it goes to the ajax cart above.
$('form', $container).on('submit', theme.rsCartListener)
*/
theme.rsCartListener = function(e){
  e.preventDefault();
  theme.cart.addToCart($(this).serialize())
  setTimeout(function(){
    console.log('here2')
  theme.RightDrawer.open()
  },1);
  //May need to wait for the cart submit to complete

  //the on cartupdate will reload the content, but .open() will display the old cart first.
  //animation might cover that naturally?
  return false;
};


/** add +/- buttons around an input
 * requires that the inputs not be siblings
 */
theme.adjusters = function ($container) {
  //decorate the number inputs
  $('input[type="number"]',$container).each(function(i,o) {
    var $o = $(o);
    $o.before('<button class="rs-quant minus">-</button>');//accessibility?
    $o.after('<button class="rs-quant plus">+</button>');//accessibility?
  })
  $container.addClass('rs-quant-home');
  //test: better, a or b?
  $('.rs-quant', $container).on('click', function(e) {
  //$container.on('click','.rs-quant', function(e) {
    e.preventDefault();//maybe not a button?
    var $this = $(this), $input = $this.siblings('input'), value = parseInt($input.val()), out;
    !isNaN(value) && (out = (value + ($this.hasClass('plus')?1:-1)))>=0 && $input.val(out);
  });
}

/**
 Uses the browser's concept of currency instead of the string settings coming from the Shopify
 */
theme.toMoney = function(str) {
  //Eventually: currency translation?
  return parseFloat((str)/100).toLocaleString(undefined, {style:'currency',currency:theme.currency,currencyDisplay:theme.currencyDisplay})
  //locale is kind-of slow.
}

pReady.push(function() {



  //boot up libraries
  theme.cart = new theme.rsCart();
  theme.LeftDrawer = new theme.Drawers('NavDrawer', 'left');//eventually: consistant caps
  theme.RightDrawer = new theme.Drawers('CartDrawer', 'right', {
    'onDrawerOpen': function(){theme.cart.showCart('#ajaxcart')}
  });


  //Integrate libraries with page.
  //In general, libraries emit something you need to listen for here, or listen to buttons in the UI to call lib functions.
  //Ideally, don't do actual work here.

  $('#CartDrawerB,#CartDrawerBM').on('click', function(e){
    e.preventDefault();
    theme.RightDrawer.open(e);
  })
  $('#NavDrawerB').on('click', function(e){
    e.preventDefault();
    theme.LeftDrawer.open(e);
  })

  //Ajax cart support.
  var cartupdater = function($event, cart) {
    console.log('  var cartupdatersssssss');
    $('.cart-count').text(cart.items.length);
    $('.CartCost').text(theme.toMoney(cart.total_price));
    if (theme.RightDrawer.drawerIsOpen) {
      theme.cart.showCart('#ajaxcart');
      swellCheckitems();
      if (location.pathname == '/cart') {//are we editing the ajax cart while looking at the cart page?
        //theme.cart.showCart('#cartTemplate');
        //won't work with the different ajax cart page
        window.location.reload();
      }
    }
  }
  $('body').on('cartupdate', cartupdater).on('cartfail', function(){$('.carterror').show()})
  // bind cart submit button
  $('#cartTemplate').on('submit', 'form', function(e){//form needed? who else is submitting things?
    e.preventDefault();
    theme.cart.updateCart($(this).serialize())
    theme.RightDrawer.open()
  })

  $('#ajaxcart').on('click', 'input[name=checkout]', function(e){
    if(SAMPLE_POPUP_ENABLED){
      e.preventDefault();
      if (screen.width < 1280) {
        $('#CartDrawer .js-drawer-close').click();
      }
      freegifts();
      return false;
    }
  })
  //cart button
  .on('click','.cartremover',function (e){
    e.preventDefault();
    theme.cart.removeFromCart($(this).data('variant-id'))
  })
  //cart button
  .on('click','.rs-quant',function (e){
    e.preventDefault();
    var i = 0;//$(this).hasClass('q-plus')?1:-1; Already done?
    var $val = $(this).siblings('input');

    var updates = {};
    updates[$val.data('variant-id')] = parseInt($val.val())+i;
    theme.cart.updateCart({updates: updates});
  })

});

function swellCheckitems()
{
  var cart = $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(){
      if(cart.responseJSON.item_count>0){
        var isPricedItem = 0;
        cart.responseJSON.items.forEach(function(item)
        {
          if(item.final_price > 0)
          {
            if(item.properties["_swell_discount_type"] === undefined)
            {
              isPricedItem = 1;
              return false;
            }
          }
        });
        setTimeout(function(){
          if(isPricedItem == 0)
          {
            $(".js-drawer-close").click();
            $.ajax({
              type: "POST",
              url: '/cart/clear.js',
              success: function(){
                console.log("swellCleared");
                theme.cart.showCart('#ajaxcart');
              },
              dataType: 'json'
            });
          }
        }, 1000);
      }
    }
  });
}
